import styled from "styled-components";
import { TestingConstants } from "../../CommonUI/Testing/TestingConstants";
import { UIStyleConstants } from "../../rule-engine-core/Common/UIStyleConstants";

export const RuleEditorDiv = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
`;

export const RuleDesignerRender = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    overflow: auto;
    background: ${UIStyleConstants.WHITE_SEMI_DARK_COLOR};
    position: relative;
`;

export const RuleToolbarRender = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 16px 24px 8px;
    border-bottom: 1.5px solid ${UIStyleConstants.GRAY_LIGHTER_COLOR};

    .RuleHeader-button {
        font-size: 12px;
        font-style: normal;
        line-height: 17px;
        letter-spacing: 0em;
        font-weight: 500;
        text-align: center;
        color: ${UIStyleConstants.BLUE_COLOR};

        padding: 0;

        margin-left: 16px;

        &:first-child {
            margin-left: 0;
        }
    }
`;

export const RuleEditorRender = styled.div<{ columnCount: number; rowsGap?: number; columnsGap?: number }>`
    display: grid;
    padding: 16px 24px;
    justify-items: stretch;

    grid-template-columns: repeat(${(props) => props.columnCount + 3}, [col-start] max-content [col-end]);
    column-gap: ${(props) => props.columnsGap || 2}px;
    row-gap: ${(props) => props.rowsGap || 2}px;
`;

export const RuleTableIndexColumn = styled.div<{ height?: number; x?: number; y?: number; isTestPassed?: boolean }>`
    width: 24px;
    min-height: ${(props) => props.height || 24}px;

    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 17px;
    letter-spacing: 0px;

    ${(props) => (props.isTestPassed ? "background: " + UIStyleConstants.GREEN_COLOR + ";" : "")}

    display: flex;
    align-items: center;
    justify-content: center;

    color: ${UIStyleConstants.TEXT_COLOR_DEFAULT};

    position: relative;

    ${(props) =>
        props.x !== undefined
            ? `
                grid-column-start: ${props.x + 1};
                grid-column-end: ${props.x + 2};
            `
            : ``}
    ${(props) =>
        props.y !== undefined
            ? `
                grid-row-start: ${props.y + 1};
                grid-row-end: ${props.y + 2};
            `
            : ``}
  img {
        position: absolute;
        left: -20px;
        top: 50%;
        transform: translateY(-50%);
    }
`;

export const RuleTableHeaderActionColumn = styled.div<{ disabled?: boolean; x?: number; y?: number }>`
    display: flex;
    background: ${UIStyleConstants.GRAY_LIGHT_COLOR};
    border-radius: 2px;
    align-items: center;
    justify-content: center;
    width: 24px;

    ${(props) => (props.disabled ? "pointer-events: none;" : "")}
    cursor: pointer;
    ${(props) =>
        props.x !== undefined
            ? `
                grid-column-start: ${props.x + 1};
                grid-column-end: ${props.x + 2};
            `
            : ``}
    ${(props) =>
        props.y !== undefined
            ? `
                grid-row-start: ${props.y + 1};
                grid-row-end: ${props.y + 2};
            `
            : ``}
`;

export const RuleTableRuleColumn = styled.div<{
    selected: boolean;
    x: number;
    y: number;
    backgroundColor?: string;
    borderColor?: string;
}>`
    background: ${(props) => props.backgroundColor || UIStyleConstants.WHITE_COLOR};
    border-radius: 2px;

    position: relative;

    transition: border-color 0.1s ease-in;

    //styleName: text/Inter Regular 12px;

    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 17px;
    letter-spacing: 0px;
    text-align: left;

    color: ${UIStyleConstants.TEXT_COLOR_DEFAULT};

    &:hover {
        border: 1px solid ${UIStyleConstants.BLUE_GRAY_COLOR};
    }

    ${(props) =>
        props.selected
            ? `border: 1px solid ${props.borderColor || UIStyleConstants.BLUE_GRAY_COLOR};`
            : `border: 1px solid ${props.borderColor || "" + UIStyleConstants.GRAY_LIGHTER_COLOR};`}

    ${(props) =>
        props.x !== undefined
            ? `
                grid-column-start: ${props.x + 1};
                grid-column-end: ${props.x + 2};
                    `
            : ``}
  ${(props) =>
        props.y !== undefined
            ? `
                grid-row-start: ${props.y + 1};
                grid-row-end: ${props.y + 2};
            `
            : ``}
`;

export const RuleTableEmptyColumn = styled.div<{ colSpan?: number; colStart?: number }>`
    background: ${UIStyleConstants.GRAY_VERY_LIGHT_COLOR};
    min-width: 120px;
    border-radius: 2px;
    min-height: 24px;

    ${(props) =>
        props.colSpan
            ? `
                grid-column-start: ${(props.colStart || 0) + 1};
                grid-column-end: ${(props.colStart || 0) + 1 + props.colSpan}`
            : ``}
`;

export const RuleLabelColumn = styled.div<{ colSpan?: number; colStart?: number; y?: number }>`
    min-width: 120px;
    border-radius: 2px;
    min-height: 24px;

    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    -webkit-letter-spacing: 0px;
    -moz-letter-spacing: 0px;
    -ms-letter-spacing: 0px;
    letter-spacing: 0px;

    display: flex;
    align-items: center;
    justify-content: flex-end;

    color: ${UIStyleConstants.TEXT_COLOR_DEFAULT};

    padding: 5px 10px;

    ${(props) =>
        props.y !== undefined
            ? `
                grid-row-start: ${props.y + 1};
                grid-row-end: ${props.y + 2};
            `
            : ``}

    ${(props) =>
        props.colSpan
            ? `
                grid-column-start: ${(props.colStart || 0) + 1};
                grid-column-end: ${(props.colStart || 0) + 1 + props.colSpan}`
            : ``}
`;

export const RuleTableEmptyAddColumn = styled.div<{ x?: number; y?: number; isTestPassed?: boolean }>`
    ${(props) =>
        props.isTestPassed
            ? "background: " + UIStyleConstants.GREEN_COLOR + ";"
            : "background: " + UIStyleConstants.GRAY_LIGHT_COLOR + ";"}

    width: 24px;
    border-radius: 2px;
    min-height: 24px;
    ${(props) =>
        props.x !== undefined
            ? `
                grid-column-start: ${props.x + 1};
                grid-column-end: ${props.x + 2};
            `
            : ``}
    ${(props) =>
        props.y !== undefined
            ? `
                grid-row-start: ${props.y + 1};
                grid-row-end: ${props.y + 2};
            `
            : ``}
`;

export const RuleTableEmptyIndexColumn = styled.div<{
    onClick?: () => void;
    disabled?: boolean;
}>`
    background: ${UIStyleConstants.GRAY_LIGHT_COLOR};
    min-width: 24px;
    border-radius: 2px;
    min-height: 24px;

    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 17px;
    letter-spacing: 0px;

    display: flex;
    align-items: center;
    justify-content: center;

    ${(props) => (props.onClick ? (props.disabled ? "pointer-events: none;" : "cursor: pointer;") : "")}
`;

export const RuleTableHeaderSplit = styled.div<{
    width?: number;
    height?: number;
    x?: number;
    y?: number;
}>`
    min-width: ${(props) => props.width || 120}px;
    min-height: ${(props) => props.height || 1}px;
    background: ${UIStyleConstants.GRAY_LIGHT_COLOR};
    border-radius: 1px;

    ${(props) =>
        props.x !== undefined
            ? `
                grid-column-start: ${props.x + 1};
                grid-column-end: ${props.x + 2};
            `
            : ``}
    ${(props) =>
        props.y !== undefined
            ? `
                grid-row-start: ${props.y + 1};
                grid-row-end: ${props.y + 2};
            `
            : ``}
`;

export const RuleEditorInTester = styled.div`
    display: flex;
    flex-direction: column;

    .RuleEditorRender {
        overflow: auto;
    }
`;

export const CellValuesRenderInTester = styled.div<{ isError?: boolean }>`
    padding: 6px 12px;
    display: flex;
    flex-direction: column;

    position: relative;
    width: 100%;
    height: 100%;

    ${(props) => (props.isError ? `background: ${TestingConstants.BACKGROUND_FAIL};` : "")}
`;

export const CellValueLine = styled.div<{ testResult?: "true" | "false" }>`
    margin-bottom: 5px;
    ${(props) =>
        props.testResult === "true"
            ? `color: ${UIStyleConstants.GREEN_COLOR};`
            : props.testResult === "false"
              ? `
                color: ${UIStyleConstants.RED_COLOR};
                text-decoration: line-through;
            `
              : ``};
`;

export const CellTestResultError = styled.div`
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 2;
    cursor: pointer;
`;
